"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateableCustomerDataToJSON = exports.UpdateableCustomerDataFromJSONTyped = exports.UpdateableCustomerDataFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function UpdateableCustomerDataFromJSON(json) {
    return UpdateableCustomerDataFromJSONTyped(json, false);
}
exports.UpdateableCustomerDataFromJSON = UpdateableCustomerDataFromJSON;
function UpdateableCustomerDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
        'phoneNumbers': !(0, runtime_1.exists)(json, 'phoneNumbers') ? undefined : (json['phoneNumbers'].map(_1.PhoneNumberWithTypeFromJSON)),
        'birthName': !(0, runtime_1.exists)(json, 'birthName') ? undefined : json['birthName'],
    };
}
exports.UpdateableCustomerDataFromJSONTyped = UpdateableCustomerDataFromJSONTyped;
function UpdateableCustomerDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phoneNumbers': value.phoneNumbers === undefined ? undefined : (value.phoneNumbers.map(_1.PhoneNumberWithTypeToJSON)),
        'birthName': value.birthName,
    };
}
exports.UpdateableCustomerDataToJSON = UpdateableCustomerDataToJSON;
//# sourceMappingURL=UpdateableCustomerData.js.map